import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/TM_Capabara_Logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/homepage/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayerView"] */ "/vercel/path0/src/llm/LayerView.tsx");
